import { Box, Divider, Grid, Paper, Stack, Typography } from '@mui/material';
import ChartRow from './ChartRow';
import { StatBoxType, Statistics } from '../../modules/location/model';
import NumberCircularProgress from './CircularProgressionBox';

interface CurrentStatisticsBoxProps {
  stats?: Statistics;
  name: string;
  statType: StatBoxType;
  circularStats?: Statistics;
}

const StatisticsBox = ({ stats, name, statType, circularStats }: CurrentStatisticsBoxProps) => {
  return (
    <Paper sx={{ borderRadius: '10px', border: '1px solid #E2E8F0', boxShadow: '10px 5px 10px #EFEFEF', padding: '16px 24px', flexGrow: '1' }}>
      <Grid container>
        <Grid item xs={12}>
          <Typography sx={{ fontFamily: 'Inter', fontWeight: '700', fontSize: '1.28rem' }}>{getTitle(statType, name)}</Typography>
        </Grid>
        <Grid item xs={12}>
          <Stack direction="row" spacing={1}>
            <Typography sx={{ fontWeight: '600', fontSize: '0.85rem', color: '#718096' }}>Parkingi - </Typography>
            <Typography sx={{ fontWeight: '600', fontSize: '0.85rem' }}>{name}</Typography>
          </Stack>
        </Grid>
        <Grid item xs={12} sx={{ mt: 1 }}>
          <Stack direction={{ sm: 'column', md: 'row' }}>
            <Box sx={{ height: 192 }}>
              <NumberCircularProgress value={getPerc(circularStats?.data?.takenSpots ?? 0, circularStats?.data?.capacity ?? 0)} type={statType} />
            </Box>
            <Divider orientation="vertical" color="#718096" flexItem sx={{ mx: 2 }}></Divider>

            <Stack direction="column" sx={{ justifyContent: 'center' }}>
              <ChartRow value={stats?.data?.entries ?? 0} content="wjazdy" statType={statType}></ChartRow>
              <ChartRow value={stats?.data?.exits ?? 0} content="wyjazdy" isDark={true} statType={statType}></ChartRow>
            </Stack>
          </Stack>
        </Grid>
      </Grid>
    </Paper>
  );
};

const getPerc = (one?: number, two?: number): number => {
  if (one && two) {
    if (one === 0 || two === 0) {
      return 0;
    }
    if (one > two) {
      return 100;
    }
    return Math.ceil((one / two) * 100);
  }
  return 0;
};

const getTitle = (type: StatBoxType, name: string) => {
  switch (type) {
    case StatBoxType.Today:
      return 'Ruch dzisiaj';
    case StatBoxType.WhiteList:
      return 'Biała lista';
    case StatBoxType.TicketSales:
      return 'Sprzedane bilety';
    case StatBoxType.Traffic:
      return 'Ruch drogowy';
    default:
      return name;
  }
};

export default StatisticsBox;
